class StickyPurchaseBar extends HTMLElement {
  #purchaseArea;
  #primaryButton;
  #stickyButton;
  #observer;
  #mutationObserver;
  #mode = 'choose';

  connectedCallback() {
    const section = this.closest('.shopify-section');

    this.#purchaseArea = section?.querySelector('.buy-buttons-block');
    this.#primaryButton = this.#purchaseArea?.querySelector('[ref="addToCartButton"]');
    this.#stickyButton = this.querySelector('[data-sticky-purchase-button]');

    if (!this.#purchaseArea || !this.#primaryButton || !this.#stickyButton) {
      this.remove();
      return;
    }

    this.#stickyButton.addEventListener('click', this.#handleClick);

    this.#observer = new IntersectionObserver(this.#handleIntersection, {
      threshold: 0.15,
    });
    this.#observer.observe(this.#purchaseArea);

    this.#mutationObserver = new MutationObserver(this.#syncButtonState);
    this.#mutationObserver.observe(this.#primaryButton, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      subtree: true,
    });

    this.#syncButtonState();
  }

  disconnectedCallback() {
    this.#stickyButton?.removeEventListener('click', this.#handleClick);
    this.#observer?.disconnect();
    this.#mutationObserver?.disconnect();
  }

  #handleIntersection = ([entry]) => {
    if (entry.isIntersecting) {
      this.hidden = true;
      return;
    }

    this.#mode = entry.boundingClientRect.top < 0 ? 'add' : 'choose';
    this.#syncButtonState();
    this.hidden = false;
  };

  #syncButtonState = () => {
    if (!this.#stickyButton || !this.#primaryButton) return;

    if (this.#mode === 'choose') {
      this.#stickyButton.disabled = false;
      this.#stickyButton.textContent = this.dataset.chooseLabel || 'Choose options';
      return;
    }

    const primaryLabel = this.#primaryButton.querySelector('.add-to-cart-text__content')?.textContent?.trim();

    this.#stickyButton.disabled = this.#primaryButton.disabled;
    this.#stickyButton.textContent = primaryLabel || this.dataset.addLabel || 'Add to cart';
  };

  #handleClick = () => {
    if (!this.#primaryButton || !this.#purchaseArea) return;

    if (this.#mode === 'add' && !this.#primaryButton.disabled) {
      this.#primaryButton.click();
      return;
    }

    const decisionArea = this.closest('.shopify-section')?.querySelector('variant-picker, .product__grind-size');
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    (decisionArea || this.#purchaseArea).scrollIntoView({ behavior, block: 'center' });
  };
}

if (!customElements.get('sticky-purchase-bar')) {
  customElements.define('sticky-purchase-bar', StickyPurchaseBar);
}
